import AddProgramAssistant from './AddProgramAssistant';

export default AddProgramAssistant;
